<ngx-spinner [name]="spinner1" [fullScreen]="true"><span class="badge badge-info p-2">Autorisierung wird
    durchgeführt...</span></ngx-spinner>
<div class="modal-header">
  <div id="staticBackdropLabel" *ngIf="entity" class="w-100">
    <h5 class="modal-title" i18n="@@EntityNameHeader">
      <span class="float-start">
        {{ entity.name }}

      </span>
      <div class="d-flex float-end">
        <span class="badge rounded-pill bg-danger text-white me-2 p-2" *ngIf="offlineTimes > 1" ngbTooltip="In den letzten 24 Stunden war diese Ladestation {{offlineTimes}} mal vom System getrennt.">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-wifi-off">
            <line x1="1" y1="1" x2="23" y2="23"></line>
            <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path>
            <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path>
            <path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path>
            <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path>
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
            <line x1="12" y1="20" x2="12.01" y2="20"></line>
          </svg>
          <span class="ms-2">{{ offlineTimes }}</span>
        </span>
        <charging-station-combined-status-badge class="pe-3" [chargingStation]="entity"></charging-station-combined-status-badge>
      </div>
    </h5>
  </div>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
    (click)="onCancelClick()"></button>
</div>

<div class="modal-body">
  <ul ngbNav #hnav="ngbNav" [(activeId)]="activeTab" [class]="'nav-tabs nav-pills'">
    <li [ngbNavItem]="1" domId="tab_info">
      <a ngbNavLink i18n="@@InfoLink">Steuerung</a>
      <ng-template ngbNavContent>
        <app-charging-station-info #ChargingStationInfo [isAvailable]="isAvailable"
                                   (entityLoadedEvent)="onEntityLoadedEvent($event)"></app-charging-station-info>
      </ng-template>
    </li>
    <li [ngbNavItem]="2" domId="tab_details">
      <a ngbNavLink i18n="@@DetailsLink" *ngIf="this.customer || this.operator || this.user">Details</a>
      <ng-template ngbNavContent>
        <app-details-charging-station #detailsChargingStation
                                      (entityLoadedEvent)="onEntityLoadedEvent($event)"></app-details-charging-station>
      </ng-template>
    </li>
    <li [ngbNavItem]="3" domId="tab_dlm_management" [disabled]="entity?.chargingPoints[0]?.statusId == 1">
      <a ngbNavLink i18n="@@dlmLink" class="{{ entity?.chargingPoints[0]?.statusId == 1?'text-muted':'' }}"
         *ngIf="permissions?.chargingstationDetailsTransactions && this.operator && isManufacturerDLM && !isSupporter">Lastmanagement</a>
      <ng-template ngbNavContent>
        <app-dlm-charging-station #chargingStationDlm [customerId]="customerId"
                                  (entityLoadedEvent)="onEntityLoadedEvent($event)"></app-dlm-charging-station>
      </ng-template>
    </li>
    <li [ngbNavItem]="4" domId="tab_authorization" [disabled]="entity?.chargingPoints[0]?.statusId == 1" *ngIf="this.entity?.manufacturer?.name !== 'Vector'">
      <a ngbNavLink i18n="@@AuthorizationLink" *ngIf="this.customer || this.operator" class="{{ entity?.chargingPoints[0]?.statusId == 1?'text-muted':'' }}">Autorisierung</a>
      <ng-template ngbNavContent>
        <app-charging-station-rfid-auth [isOperator]="isOperatorView" (entityLoadedEvent)="onEntityLoadedEvent($event)"
                                        #chargingStationRfidAuth></app-charging-station-rfid-auth>
      </ng-template>
    </li>

    <li [ngbNavItem]="5" domId="tab_system" [disabled]="entity?.chargingPoints[0]?.statusId == 1">
      <a ngbNavLink i18n="@@ChargingSysLink" *ngIf="this.operator && !isSupporter" class="{{ entity?.chargingPoints[0]?.statusId == 1?'text-muted':'' }}">System</a>
      <ng-template ngbNavContent>
        <app-sys-charging-station [entity]="this.entity"></app-sys-charging-station>
      </ng-template>
    </li>
    <li [ngbNavItem]="6" domId="tab_notes" [disabled]="entity?.chargingPoints[0]?.statusId == 1">
      <a ngbNavLink i18n="@@ChargingNotesLink" *ngIf="this.operator && !isSupporter" class="{{ entity?.chargingPoints[0]?.statusId == 1?'text-muted':'' }}">Notizen</a>
      <ng-template ngbNavContent>
        <app-notes-charging-station [entity]="this.entity"></app-notes-charging-station>
      </ng-template>
    </li>
  </ul>

  <div class="tab-content" id="nav-tabContent">
    <div [ngbNavOutlet]="hnav" class="mt-2"></div>
  </div>
  <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
    <div class="modal-content m-0 p-0" role="document" style="width:30rem;max-width:90%">
      <div class="modal-dd">
        <div class="modal-header">
          <div class="container-fluid g-0 clearfix">
            <div class="col-9 float-start p-0">
              <h4 class="mb-0 pb-0">Support &amp; Feedback senden</h4>
            </div>
            <div class="col-3 float-end p-0 text-end">
              <button type="button" class="btn-end btn-close" aria-label="Close" (click)="onCloseHandled()"></button>
            </div>
          </div>
        </div>

        <div class="modal-body">
          <label i18n="@@TicketDescriptionLabel" for="ticket">
            Ihre Nachricht:
          </label>
          <textarea name="ticket" form-control-name="ticket" class="w-100 text-dark" rows="8" cols="160"
                    (input)="onValueChange($event)"></textarea>
        </div>

        <div class="modal-footer m-0">
          <div class="container-fluid m-0 p-0">
            <div class="col-6 float-start p-1"><button type="button" class="btn btn-default" (click)="onCloseHandled()"
                i18n="@@TransactionCloseBtnText">Abbrechen</button></div>
            <div class="col-6 float-end p-1"><button type="button" class="btn btn-save float-end pull-right"
                (click)="sendTicket()" i18n="@@TransactionCloseBtnText">Absenden</button></div>
          </div>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal !-->
</div>

<div class="modal-footer">
  <button class="btn" id="triggerDiagnosticSuppoertTicket" (click)="createTicket(entity?.id)"
          data-bs-placement="left" i18n="@@GetDiagnosticsButton">
    <app-svg source="icons/feather/support" height="18"></app-svg>
    <span class="ps-2 d-none d-lg-inline">
      Support
    </span>
  </button>
  <div ngbDropdown placement="top-end" class="d-inline-block" #settingsDropdown="ngbDropdown" [autoClose]="true" *ngIf="!this.user">
    <button type="button" class="btn btn-warning" id="dropdownBasic2" ngbDropdownToggle>
      <app-svg source="icons/feather/settings" height="18" style="margin:0; padding:0;"></app-svg>
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownBasic2"
         style="padding:0 !important;width:auto !important;min-width:0.125em !important">
      <button class="btn" id="EnableHubjectERoaming" *ngIf="this.operator && !this.isHubjectCompatible"
              (click)="enableHubjectERoaming(entity?.id)" [disabled]="isSupporter" data-bs-placement="left"
              i18n="@@EnableHubjectERoaming">
        <app-svg source="icons/feather/upload-cloud" height="18"></app-svg><br /><span>Roaming aktivieren</span>
      </button>
      <button class="btn" id="DisableHubjectERoaming" *ngIf="this.operator && this.isHubjectCompatible"
              (click)="disableHubjectERoaming(entity?.id)" [disabled]="isSupporter" data-bs-placement="left"
              i18n="@@TurnOffHubjectERoaming">
        <app-svg source="icons/feather/cloud-off" height="18"></app-svg><br /><span>Roaming deaktivieren</span>
      </button>
      <button *ngIf="this.operator || this.isProduction" id="delete" class="btn" data-bs-dismiss="modal"
              (click)="openDeleteDialog()" [disabled]="isSupporter" i18n="@@DeleteChargingStationButton">
        <app-svg source="icons/feather/trash-2" height="18"></app-svg><br /><span>Ladestation löschen</span>
      </button>
      <button class="btn" id="restart" *ngIf="config?.isRestartButtonVisible && !this.user" (click)="openResetDialog();"
              [disabled]="entity?.chargingPoints[0]?.statusId == 1" i18n="@@RestartChargingStationButton">
        <app-svg source="icons/feather/refresh-cw" height="18"></app-svg><br /><span>Ladestation neustarten</span>
      </button>
      <button class="btn" id="setAvailable" *ngIf="!isAvailable && !this.user" (click)="setAvailable();" [disabled]="unlockDisabled"
              i18n="@@setAvailableButton">
        <app-svg source="icons/feather/zap" height="18"></app-svg><br /><span>Ladestation entsperren</span>
      </button>
      <button class="btn" id="setUnavailable" *ngIf="isAvailable && !this.user" (click)="setUnavailable();" [disabled]="unlockDisabled"
              i18n="@@setUnavailableButton">
        <app-svg source="icons/feather/zap-off" height="18"></app-svg><br /><span>Ladestation sperren</span>
      </button>
      <button class="btn" id="reset_password" *ngIf="config?.isResetPasswordButtonVisible && !this.user && !isSupporter"
              (click)="openResetPasswordDialog();" [disabled]="entity?.chargingPoints[0]?.statusId == 1"
              data-bs-placement="left" i18n="@@ResetPasswordButton">
        <app-svg source="icons/feather/tool" height="18"></app-svg><br /><span>Passwort zurücksetzen</span>
      </button>
    </div>
  </div>
  <button type="button" id="cancel" class="btn btn-yellow d-inline me-1" data-bs-dismiss="modal"
          (click)="onCancelClick()" i18n="@@CancelButton">
    Schließen
  </button>

  <form [formGroup]="formService.form" (ngSubmit)="detailsChargingStation.onSubmit(formService.form?.value)"
        *ngIf="(entity && activeTab == 2) && !this.user" class=" d-inline">
    <button type="submit" id="save" class="btn btn-save"
            [disabled]="!formService.form?.valid || !formService.form?.dirty || isSupporter"
            (ngSubmit)="detailsChargingStation.onSubmit(formService.form?.value)"
            *ngIf="(entity && activeTab == 2) && !this.user" i18n="@@SaveButton">
      Speichern
    </button>
  </form>

  <form [formGroup]="formService.form" (ngSubmit)="chargingStationDlm.onSubmit(formService.form?.value)"
        *ngIf="(entity && activeTab == 3) && this.operator && !chargingStationDlm?.isRestartNecessary" class=" d-inline">
    <button type="submit" id="save" class="btn btn-save"
            [disabled]="!formService.form?.valid || !formService.form?.dirty || isSupporter" i18n="@@SaveButton">
      Speichern
    </button>
  </form>

  <form [formGroup]="formService.form" (ngSubmit)="chargingStationDlm.showConfirmRestartDialog(formService.form?.value)"
        *ngIf="(entity && activeTab == 3) && this.operator && chargingStationDlm?.isRestartNecessary" class=" d-inline">
    <button type="submit" id="save" class="btn btn-save" [disabled]="!formService.form?.valid || isSupporter"
            i18n="@@SaveAndRestartButton">
      Speichern und Neustarten
    </button>
  </form>

  <form [formGroup]="formService.form" (ngSubmit)="chargingStationRfidAuth.onSubmit(formService.form?.value)"
        *ngIf="(entity && activeTab == 4) && !this.user" class=" d-inline">
    <button type="submit" id="save" class="btn btn-save" [disabled]="!formService.form?.dirty || isSupporter"
            i18n="@@SaveButton">
      Speichern
    </button>
  </form>
</div>
